import { ContextWrapper } from '@common/contexts/ContextWrapper';
import { ClientStore } from '@hospital/views/clients/ClientStore';


export const ClientStoreContextWrapper = new ContextWrapper<ClientStore>();
